export default __webpack_public_path__ + "static/media/Banner_Intro.9647dabb.png";